import { EnvironmentProviders, Provider } from '@angular/core';
import { provideStore } from './store/store.providers';
import { provideResources } from './data/resource.providers';
import { sortProviders } from './sort/sort.providers';
import { v4 as uuidv4 } from 'uuid';
import { Logger } from './log/logger';
import { Mediator } from './mediator/mediator';
import { filterProviders } from './filter/filter.providers';
import { telemetryProviders } from './telemetry/telemetry.providers';
import { SOFTLINE_CONFIG_COOKIE_PREFIX, SOFTLINE_SERVICE_HTTP, SOFTLINE_SERVICE_UUID } from './core.shared';
import { DateService } from './date-time/date.service';
import { MomentDateService } from './date-time/moment-date.service';
import { ConnectionHttpService } from './data/specialized/http/connection-http.service';
import { WrappedResourceService } from './data/specialized/wrapped-resource.service';
import { ResponseResult } from './data/specialized/http/response-result';

export const provideCore: () => Array<Provider | EnvironmentProviders> = () => {
  return [
    provideStore([]),
    provideResources(),

    Logger,
    Mediator,

    filterProviders,
    sortProviders,
    telemetryProviders,

    { provide: SOFTLINE_CONFIG_COOKIE_PREFIX, useValue: 'Softline' },
    { provide: SOFTLINE_SERVICE_UUID, useValue: () => uuidv4() },
    { provide: DateService, useClass: MomentDateService },
    {
      provide: SOFTLINE_SERVICE_HTTP,
      useFactory: (service: ConnectionHttpService) =>
        new WrappedResourceService(
          service,
          (response: ResponseResult<any>) => response?.result
        ),
      deps: [ConnectionHttpService],
    },
    ];
}
